import { put, takeLatest, delay } from "redux-saga/effects";

import authenticationService from "../../../services/authentication";
import Metamask from "../../../services/metamask";
import session from "../../../utils/session";
import {
  connectMetamaskFailure,
  connectMetamaskStart,
  connectMetamaskSuccess,
  forgotPasswordFailure,
  forgotPasswordStart,
  forgotPasswordSuccess,
  loginFailure,
  loginStart,
  loginSuccess,
  logoutFailure,
  logoutStart,
  logoutSuccess,
  refreshLoginFailure,
  refreshLoginStart,
  refreshLoginSuccess,
  refreshMetamaskLoginStart,
  refreshMetamaskLoginSuccess,
  sbUserInitilizeFailure,
  sbUserInitilizeStart,
  sbUserInitilizeSuccess,
  signUpFailure,
  signUpStart,
  signUpSuccess,
  thirdPartyTokenLoginFailure,
  thirdPartyTokenLoginStart,
  thirdPartyTokenLoginSuccess,
  verifyEmailFailure,
  verifyEmailStart,
  verifyEmailSuccess,
  verifyPasswordTokenFailure,
  verifyPasswordTokenStart,
  verifyPasswordTokenSuccess
} from "../../redux/auth/authentication";
import {
  metamaskLoginFailure,
  metamaskLoginStart,
  metamaskLoginSuccess
} from "../../redux/auth/authentication";
import { resetMyProfileState } from "../../redux/profile/myProfile";
import { resetPaymentState } from "../../redux/payment/";
import { showErrorMessage, showSuccessMessage } from "../../redux/toast";
import { resetTransactionState } from "../../redux/profile/transactions";
import { resetFavoritesState } from "../../redux/casino/lobby/favorites";

function* authenticationWatcher() {
  yield takeLatest(loginStart.type, loginWorker);
  yield takeLatest(refreshLoginStart.type, refreshLoginWorker);
  yield takeLatest(refreshMetamaskLoginStart.type, refreshLoginWorker);
  yield takeLatest(connectMetamaskStart.type, connectedMetamaskWorker);
  yield takeLatest(metamaskLoginStart.type, metamaskLoginWorker);
  yield takeLatest(signUpStart.type, signUpWorker);
  yield takeLatest(logoutStart.type, logoutWorker);
  yield takeLatest(verifyEmailStart.type, verifyEmailWorker);
  yield takeLatest(forgotPasswordStart.type, forgotPasswordWorker);
  yield takeLatest(verifyPasswordTokenStart.type, verifyPasswordTokenWorker);
  yield takeLatest(sbUserInitilizeStart.type, sbInitilizeWorker);
  yield takeLatest(thirdPartyTokenLoginStart, thirdPartyTokenLoginWorker);
}

function* loginWorker(action) {
  try {
    const { data, error } = yield authenticationService.login(action.payload);
    if (data) {
      const { token, resToken, isMetaMaskUser, userId, betToken } = data;
      session.saveSessionCred({
        token,
        resToken,
        betToken,
        isMetaMaskUser,
        userId
      });
      yield put(showSuccessMessage({ tKey: "HEADER.LOGIN_SUCCESS" }));
      yield put(loginSuccess(userId));
      // yield put(sbUserInitilizeStart({ token: betToken }));
    }

    if (error) {
      yield put(showErrorMessage({ msg: error.message }));
      yield put(loginFailure());
    }
  } catch (error) {
    yield put(showErrorMessage({ msg: error.message }));
    yield put(loginFailure());
  }
}

function* refreshLoginWorker(action) {
  try {
    const { data, error } = yield authenticationService.refreshLogin(
      action?.payload
    );
    if (data) {
      const { token, resToken, isMetaMaskUser, walletAddress, betToken } = data;
      const { id } = JSON.parse(atob(token.split(".")[1]));
      session.saveSessionCred({
        token,
        resToken,
        betToken,
        isMetaMaskUser,
        userId: id
      });
      if (isMetaMaskUser) {
        yield put(refreshMetamaskLoginSuccess({ walletAddress }));
        // yield put(sbUserInitilizeStart({ token: betToken }));
      } else {
        yield put(refreshLoginSuccess({ id, walletAddress }));
        // yield put(sbUserInitilizeStart({ token: betToken }));
      }
    }

    if (error) {
      yield put(refreshLoginFailure(error.message));
      yield delay(1500);
      session.clearSessionCred();
      if (action?.payload?.thirdPartyToken) {
        yield put(showSuccessMessage({ tKey: "HEADER.TOKEN_EXPIRED" }));
      } else {
        yield put(showErrorMessage({ tKey: "HEADER.SESSION_TIMEOUT" }));
      }
      // window.location.href = "/";
    }
  } catch (error) {
    yield put(refreshLoginFailure(error.message));
    yield delay(1500);
    session.clearSessionCred();
    if (action?.payload?.thirdPartyToken) {
      yield put(showSuccessMessage({ tKey: "HEADER.TOKEN_EXPIRED" }));
    } else {
      yield put(showErrorMessage({ tKey: "HEADER.SESSION_TIMEOUT" }));
    }

    // window.location.href = "/";
  }
}

function* connectedMetamaskWorker(action) {
  try {
    const { data, error } = yield Metamask.connectToMetamask(action.payload);
    if (data === "REDIRECTED_TO_MOBILE_APP") {
      window.location.href = "/";
      return;
    }
    if (data) {
      yield put(
        showSuccessMessage({ tKey: "HEADER.METAMASK_CONNECT_SUCCESS" })
      );
      yield put(connectMetamaskSuccess(data));
    }
    if (error) {
      yield put(showErrorMessage({ msg: error.message }));
      yield put(connectMetamaskFailure());
    }
  } catch (error) {
    yield put(showErrorMessage({ msg: error.message }));
    yield put(connectMetamaskFailure());
  }
}

function* metamaskLoginWorker(action) {
  try {
    const { data, error } = yield Metamask.requestAccount(action.payload);
    if (data === "REDIRECTED_TO_MOBILE_APP") {
      window.location.href = "/";
      return;
    }
    if (data) {
      const { token, resToken, isMetaMaskUser, walletAddress, betToken } = data;
      session.saveSessionCred({
        token,
        betToken,
        resToken,
        isMetaMaskUser
      });
      yield put(showSuccessMessage({ tKey: "HEADER.METAMASK_LOGIN_SUCCESS" }));
      yield put(metamaskLoginSuccess(walletAddress));
    }
    if (error) {
      yield put(showErrorMessage({ msg: error.message }));
      yield put(metamaskLoginFailure());
    }
  } catch (error) {
    yield put(showErrorMessage({ msg: error.message }));
    yield put(metamaskLoginFailure());
  }
}

function* signUpWorker(action) {
  try {
    const { data, error } = yield authenticationService.signUp(action.payload);
    // if (data) {
    //   yield put(
    //     showSuccessMessage({
    //       tKey: data.emailUsedInSignup
    //         ? "HEADER.EMAIL_SUCCESS"
    //         : "HEADER.USERNAME_SIGNUP_SUCCCESS",
    //     })
    //   );
    //   yield put(signUpSuccess());
    // }
    if (data) {
      const { token, resToken, isMetaMaskUser, userId, betToken } = data;
      session.saveSessionCred({
        token,
        resToken,
        betToken,
        isMetaMaskUser,
        userId
      });
      yield put(signUpSuccess());
      yield put(loginSuccess(userId));
      yield put(
        showSuccessMessage({ tKey: "HEADER.USERNAME_SIGNUP_SUCCCESS" })
      );
    }
    if (error) {
      yield put(showErrorMessage({ msg: error.message }));
      yield put(signUpFailure());
    }
  } catch (error) {
    yield put(showErrorMessage({ msg: error.message }));
    yield put(signUpFailure());
  }
}

function* verifyEmailWorker(action) {
  try {
    const { data, error } = yield authenticationService.verifyEmail(
      action.payload
    );
    if (data?.emailVerified) {
      yield put(verifyEmailSuccess());
    }
    if (error) {
      yield put(verifyEmailFailure(error.message));
    }
  } catch (error) {
    yield put(verifyEmailFailure(error.message));
  }
}

function* forgotPasswordWorker(action) {
  try {
    const { data, error } = yield authenticationService.forgotPassword(
      action.payload
    );
    if (data) {
      yield put(
        showSuccessMessage({ tKey: "HEADER.FORGOT_PASSWORD_EMAIL_MSG" })
      );
      yield put(forgotPasswordSuccess());
    }
    if (error) {
      yield put(forgotPasswordFailure(error.message));
    }
  } catch (error) {
    yield put(forgotPasswordFailure(error.message));
  }
}

function* verifyPasswordTokenWorker(action) {
  try {
    const { data, error } = yield authenticationService.verifyPasswordToken(
      action.payload
    );
    if (data) {
      yield put(
        showSuccessMessage({ tKey: "CHANGE_PASSWORD.PASSWORD_CHANGE_SUCCESS" })
      );
      yield put(verifyPasswordTokenSuccess());
    }
    if (error) {
      yield put(verifyPasswordTokenFailure(error.message));
    }
  } catch (error) {
    yield put(verifyPasswordTokenFailure(error.message));
  }
}

function* logoutWorker() {
  try {
    session.clearSessionCred();
    // yield put(showSuccessMessage({ tKey: "SIDEBAR.LOG_OUT_SUCCESS" }));
    yield put(showSuccessMessage({ tKey: "HEADER.LOG_OUT_SUCCESS" }));
    yield put(logoutSuccess());
    yield put(resetMyProfileState());
    yield put(resetPaymentState());
    yield put(resetTransactionState());
    yield put(resetFavoritesState());
  } catch (error) {
    yield put(logoutFailure(error.message));
  }
}

function* sbInitilizeWorker(action) {
  try {
    const { data, error } = yield authenticationService.sbInitilize(
      action.payload
    );
    if (data) {
      yield put(sbUserInitilizeSuccess());
    }

    if (error) {
      yield put(sbUserInitilizeFailure());
    }
  } catch (error) {
    yield put(showErrorMessage({ msg: error.message }));
    yield put(sbUserInitilizeFailure());
  }
}

function* thirdPartyTokenLoginWorker(action) {
  try {
    const { data, error } = yield authenticationService.thirdPartyLogin(
      action.payload
    );
    if (data) {
      yield put(
        showSuccessMessage({ tKey: "HEADER.YOU_WILL_REDIRECTED_SHORTLY" })
      );
      yield put(thirdPartyTokenLoginSuccess(data));
    }

    if (error) {
      yield put(showErrorMessage({ msg: error.message }));
      yield put(thirdPartyTokenLoginFailure());
    }
  } catch (error) {
    yield put(showErrorMessage({ msg: error.message }));
    yield put(thirdPartyTokenLoginFailure());
  }
}

export default authenticationWatcher;
